import clsx from "clsx";
import { LandingButterLink } from "./LandingButterLink";

export const LandingButtonGrid = ({ data }) => {
  return (
    <section className="section-layout">
      {data?.fields?.headline && <h3>{data?.fields?.headline}</h3>}
      {data?.fields?.subheadline && <p>{data?.fields?.subheadline}</p>}
      {data?.fields?.buttons && (
        <div
          className={clsx(
            "LandingButtonGrid",
            data?.fields?.buttons_color && `LandingButtonGrid-${data?.fields?.buttons_color}`,
          )}
        >
          {data?.fields?.buttons?.map(button => (
            <LandingButterLink noStyle url={button?.button_url} key={button}>
              {button?.image && <img src={button?.image} alt={button?.image_alt} />}
              <div>
                {button?.title && <div className="LandingButtonGrid-title">{button?.title}</div>}
                {button?.subtitle && (
                  <div className="LandingButtonGrid-subtitle">{button?.subtitle}</div>
                )}
              </div>
            </LandingButterLink>
          ))}
        </div>
      )}
    </section>
  );
};
